export class UpdateServicioPropiedadRequest {
    public id:number = 0
    public id_Propiedad:number = 0
    public id_Servicio:number = 0
    public nroGestionPersonal:string = ""
    public nroCuenta:string =""
    public referenciaPago:string | null =""
}
